// This file is added to register all Invoicing store modukes.
// As store.js is too big already so we need to split modules into smaller chunks
import track from "./track"
import report from "./report"
import storageCost from "./storageCost"
import setRule from "./setRule"
import view from "./view"
import freeText from "./freeText"

export default {
    modules: {
        track,
        report,
        storageCost,
        setRule,
        view,
        freeText,
    },
}
